export const CSP_CONTENT =
  "default-src 'self' 'unsafe-inline'; " +
  "script-src 'self' 'unsafe-inline' https://cdn.tailwindcss.com; " +
  "style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; " +
  'font-src https://fonts.gstatic.com; ' +
  'img-src data: blob: https:; ' +
  "connect-src 'none'; " +
  "form-action 'none';";

export const CSP_META = `<meta http-equiv="Content-Security-Policy" content="${CSP_CONTENT}">`;

const HEAD_OPEN = /<head\b[^>]*>/i;
const HTML_OPEN = /<html\b[^>]*>/i;

/** Inject CSP <meta> at the very top of <head> so it's parsed before any script tag. */
export function injectCsp(html: string): string {
  if (html.includes('cdc-csp-injected')) return html;
  const stamped = CSP_META.replace('<meta', '<meta data-cdc-csp-injected="true"');
  if (HEAD_OPEN.test(html)) {
    return html.replace(HEAD_OPEN, (m) => `${m}${stamped}`);
  }
  if (HTML_OPEN.test(html)) {
    return html.replace(HTML_OPEN, (m) => `${m}<head>${stamped}</head>`);
  }
  return `<!doctype html><html><head>${stamped}</head><body>${html}</body></html>`;
}
